export const formattedNumber = (number: string | number) => {
	if (number && !isNaN(+number)) {
		return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	}
	return number ? number : 0;
};
